<template>
  <div class="language-changer" @mouseleave="setShowMenu(false)">
    <div class="language-changer__selected-lang" @mouseenter="setShowMenu(true)">
      <div class="language-changer__selected-lang__img">
        <img src="@img/lang-en.svg" alt="" class="lang-img" v-if="locale === 'en'">
        <img src="@img/lang-ru.svg" alt="" class="lang-img" v-else>
      </div>
      <div class="language-changer__selected-lang__letters">
        {{ locale === 'en' ? 'EN' : 'RU' }}
      </div>
    </div>

    <div class="language-changer__another-lang" v-show="showMenu" @click="changeLang()">
      <div class="language-changer__another-lang__img">
        <img src="@img/lang-en.svg" alt="" class="lang-img" v-if="locale !== 'en'">
        <img src="@img/lang-ru.svg" alt="" class="lang-img" v-else>
      </div>
      <div class="language-changer__another-lang__latters">
        {{ locale !== 'en' ? 'EN' : 'RU' }}
      </div>
      <div class="lang-arrow"/>
    </div>

  </div>
</template>

<script>
import appStore from '@storages/appStore'

export default {
  name: 'language-changer',
  data () {
    return {
      showMenu: false
    }
  },
  computed: {
    locale () {
      return appStore.getters.value('locale')
    }
  },
  methods: {
    changeLang () {
      if (this.locale === 'en') {
        this.$cookies.set('DE-Lang', 'ru', 'session')
      } else {
        this.$cookies.set('DE-Lang', 'en', 'session')
      }
      location.reload()
    },
    setShowMenu (val) {
      this.showMenu = val
    }
  }
}
</script>

<style lang="scss" scoped>
.language-changer {
  position: relative;
  // left: 5px;
  // bottom: 10px;
  // z-index: 11;
}
.lang-img {
  width: 20px;
  height: 20px;
}
.language-changer__selected-lang {
  display: flex;
  padding: 9px;
  padding-top: 20px;
  margin-top: -10px;
  cursor: pointer;
}
.language-changer__selected-lang__letters,
.language-changer__another-lang__latters {
  margin-left: 10px;
  margin-top: 2px;
  font-size: 16px;
  font-weight: bolder;
  color: black;
}
// .language-changer__another-lang__latters {
//   color: black;
// }
.language-changer__another-lang {
  position: absolute;
  top: -40px;
  display: flex;
  padding: 9px 9px 11px 9px;
  background-color: white;
  border-radius: 10px;
  box-shadow: 0px 1px 5.5px 0.5px rgba(0, 0, 0, 0.08);
}
.language-changer__another-lang:hover {
  background-color: #d3d3d3;
  cursor: pointer;
}
.lang-arrow {
  position: absolute;
  top: 40px;
  left: 30px;
  width: 0;
  border: 5px solid transparent;
  border-top: 5px solid white;
  // box-shadow: 0px 1px 15.5px 0.5px rgba(0, 0, 0, 0.08);
}
</style>



// WEBPACK FOOTER //
// src/components/common/languageChanger.vue